import { DeliveryLogType } from '@dev/ee-api/ee-api-models';

export const inProgressStatusesArray = [DeliveryLogType.ReadyToSend, DeliveryLogType.WaitingToRetry, DeliveryLogType.Sending];
